// Validation Playground — independent feature gate (pure logic).
//
// Deliberately SEPARATE from validationEngineFlag so the playground can be shown
// for demos/onboarding/screenshots WITHOUT enabling the in-builder Hypothesis
// Intake (and vice-versa). Default OFF. Precedence:
//   1. local kill (localStorage 'validation_playground_kill'=1)  → off
//   2. global env override (VITE_VALIDATION_PLAYGROUND = on|off)
//   3. local opt-in (localStorage 'validation_playground_optin'=1) → on
//   4. default                                                    → OFF

import { publicEnv } from './clientEnv';

export type PlaygroundGate = { enabled: boolean; reason: string };

export const VALIDATION_PLAYGROUND_OPTIN_KEY = 'validation_playground_optin';
export const VALIDATION_PLAYGROUND_KILL_KEY = 'validation_playground_kill';

function ls(key: string): string | null {
  try { return typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null; } catch { return null; }
}

export function validationPlaygroundGate(): PlaygroundGate {
  const on = (reason: string): PlaygroundGate => ({ enabled: true, reason });
  const off = (reason: string): PlaygroundGate => ({ enabled: false, reason });

  if (ls(VALIDATION_PLAYGROUND_KILL_KEY) === '1') return off('local_kill');
  const e = (publicEnv('VITE_VALIDATION_PLAYGROUND') ?? '').toLowerCase();
  if (e === 'on') return on('env_on');
  if (e === 'off') return off('disabled_globally');
  if (ls(VALIDATION_PLAYGROUND_OPTIN_KEY) === '1') return on('local_optin');
  return off('default_off');
}

export function engageValidationPlayground(on: boolean): void {
  try {
    if (on) localStorage.setItem(VALIDATION_PLAYGROUND_OPTIN_KEY, '1');
    else localStorage.removeItem(VALIDATION_PLAYGROUND_OPTIN_KEY);
  } catch { /* ignore */ }
}
